export default __webpack_public_path__ + "static/media/Guia_acceso2024.87ddc609.pdf";